'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('./utils');

var rotateOutDownRight = {
  from: {
    transformOrigin: 'right bottom',
    opacity: 1
  },
  to: {
    transformOrigin: 'right bottom',
    transform: (0, _utils.rotate3d)(0, 0, 1, -45),
    opacity: 0
  }
};
exports.default = rotateOutDownRight;


//////////////////
// WEBPACK FOOTER
// ./~/react-animations/lib/rotate-out-down-right.js
// module id = 787
// module chunks = 0